module.exports = __webpack_public_path__ + "img/icon-charity-Bean-Mall.fdda7bc4.png";